import actions from './incidentsActions'
import mutations from './incidentsMutations'

export default {
  namespaced: true,
  actions,
  mutations
}